/* Form */
import formValidation from "./formValidation.js";

export default (el) => {
    formValidation(el);
}
